module.exports = __webpack_public_path__ + "img/9788926396513.e28ecc2e.jpg";